import React from "react";

const Pagination = ({
  currentPage,
  totalItems,
  itemsPerPage = 100,
  onNext,
  onPrevious,
  canGoNext,
  canGoPrevious,
  isLoading,
}) => {
  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 0",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    margin: "20px 0",
    paddingLeft: "20px",
    paddingRight: "20px",
  };

  const buttonStyle = {
    padding: "10px 20px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s ease",
    minWidth: "140px",
  };

  const enabledButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#007bff",
    color: "white",
  };

  const disabledButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#e9ecef",
    color: "#6c757d",
    cursor: "not-allowed",
  };

  const infoStyle = {
    color: "#333",
    fontSize: "16px",
    fontWeight: "500",
    textAlign: "center",
    flex: 1,
  };

  return (
    <div style={containerStyle}>
      <button
        style={
          canGoPrevious && !isLoading ? enabledButtonStyle : disabledButtonStyle
        }
        onClick={onPrevious}
        disabled={!canGoPrevious || isLoading}
        onMouseEnter={(e) => {
          if (canGoPrevious && !isLoading) {
            e.target.style.backgroundColor = "#0056b3";
          }
        }}
        onMouseLeave={(e) => {
          if (canGoPrevious && !isLoading) {
            e.target.style.backgroundColor = "#007bff";
          }
        }}
      >
        ← Pagina anterioara
      </button>

      <div style={infoStyle}>
        <div>Pagina {currentPage}</div>
        <div style={{ fontSize: "14px", color: "#666", marginTop: "5px" }}>
          Total: {totalItems} inregistrari
        </div>
      </div>

      <button
        style={
          canGoNext && !isLoading ? enabledButtonStyle : disabledButtonStyle
        }
        onClick={onNext}
        disabled={!canGoNext || isLoading}
        onMouseEnter={(e) => {
          if (canGoNext && !isLoading) {
            e.target.style.backgroundColor = "#0056b3";
          }
        }}
        onMouseLeave={(e) => {
          if (canGoNext && !isLoading) {
            e.target.style.backgroundColor = "#007bff";
          }
        }}
      >
        Pagina urmatoare →
      </button>
    </div>
  );
};

export default Pagination;
